import { render, staticRenderFns } from "./systemEvents.vue?vue&type=template&id=0373387a&scoped=true&"
import script from "./systemEvents.vue?vue&type=script&lang=js&"
export * from "./systemEvents.vue?vue&type=script&lang=js&"
import style0 from "./systemEvents.vue?vue&type=style&index=0&id=0373387a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373387a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0373387a')) {
      api.createRecord('0373387a', component.options)
    } else {
      api.reload('0373387a', component.options)
    }
    module.hot.accept("./systemEvents.vue?vue&type=template&id=0373387a&scoped=true&", function () {
      api.rerender('0373387a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/retentionAnalysis/systemEvents.vue"
export default component.exports